import React from "react";
import { Table as AntdTable } from "antd";
import Pagination from "./Pagination";
const { Column } = AntdTable;
const Table = ({ loading, columns, dataSource, page, pageSize, totalItems, pagination, onPageChange, onPageSizeChange, }) => (React.createElement("div", null,
    React.createElement(AntdTable, { showHeader: true, pagination: false, loading: loading ?? false, dataSource: dataSource }, (columns || []).map(column => typeof column !== "boolean" && (React.createElement(Column, { key: column.dataIndex, title: column.title, dataIndex: column.dataIndex, render: column.render })))),
    pagination && (React.createElement(Pagination, { page: page, pageSize: pageSize, totalItems: totalItems, onPageChange: onPageChange, onPageSizeChange: onPageSizeChange }))));
Table.defaultProps = {
    loading: false,
    pagination: true,
};
export default Table;
